import { render, staticRenderFns } from "./SynergismGameHeader.vue?vue&type=template&id=c4dddef4&scoped=true&"
import script from "./SynergismGameHeader.vue?vue&type=script&lang=js&"
export * from "./SynergismGameHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dddef4",
  null
  
)

export default component.exports